// extracted by mini-css-extract-plugin
export default {"emptyTextContainer":"emptyTextContainer-Ai1A0","emptyReportText":"emptyReportText-UsG06"};